<template>
  <div id="main_content">
    <section class="faq-section">
      <div class="container">
        <div class="faq-shell">
          <div class="section-title text-center faq-heading">
            <p class="faq-kicker">{{ $t('faq.search.kicker') }}</p>
            <h3 class="sub-title wow pixFadeUp">{{ $t('faq.search.title') }}</h3>
            <p class="faq-intro">{{ $t('faq.search.description') }}</p>
          </div>

          <div class="faq-search-panel">
            <div class="faq-search-box">
              <span class="faq-search-icon">?</span>
              <input
                v-model="searchTerm"
                type="search"
                class="faq-search-input"
                :placeholder="$t('faq.search.placeholder')"
              />
            </div>

            <div class="faq-category-list" v-if="categoryOptions.length > 1">
              <button
                v-for="category in categoryOptions"
                :key="category.value"
                type="button"
                class="faq-category-button"
                :class="{ active: selectedCategory === category.value }"
                @click="selectedCategory = category.value"
              >{{ category.label }}</button>
            </div>
          </div>

          <div
            class="faq-results-summary"
          >{{ filteredQuestions.length }} {{ filteredQuestions.length === 1 ? $t('faq.search.result') : $t('faq.search.results') }}</div>

          <div class="faq-list" v-if="filteredQuestions.length">
            <details
              class="faq-item"
              v-for="(d, index) in filteredQuestions"
              :key="d.id || index"
              :open="index === 0 && !searchTerm"
            >
              <summary class="faq-question">
                <span>{{ d.questions }}</span>
                <span class="faq-toggle">+</span>
              </summary>
              <div class="faq-answer" v-html="d.answer" />
            </details>
          </div>

          <div class="faq-empty" v-else>
            <h4>{{ $t('faq.search.emptyTitle') }}</h4>
            <p>{{ $t('faq.search.emptyText') }}</p>
          </div>

          <div class="faq-contact-card">
            <div>
              <p class="faq-contact-kicker">{{ $t('faq.contact.kicker') }}</p>
              <h4>{{ $t('faq.contact.title') }}</h4>
              <p>{{ $t('faq.contact.description') }}</p>
            </div>
            <div class="faq-contact-actions">
              <a
                :href="`mailto:${supportEmail}`"
                class="faq-contact-button primary"
              >{{ supportEmail }}</a>
              <a
                :href="whatsAppUrl"
                class="faq-contact-button whatsapp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="fab fa-whatsapp"></i>
                {{ supportPhoneLabel }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="featured-four-ab">
      <div class="container">
        <div class="section-title text-center">
          <h3 class="sub-title wow pixFadeUp">{{ $t('download_now') }}</h3>
          <br />

          <h1 class="wow pixFadeUp">{{ $t('MIKMIC') }}</h1>
          <br />

          <div class="banner-button-container">
            <img :src="$themeAsset('storeImage')" />
          </div>

          <div class="banner-button-container">
            <a href="https://play.google.com/store/search?q=mikmic&c=apps">
              <img :src="$themeAsset('googleStore')" class="button-store" />
            </a>

            <a
              href="https://apps.apple.com/mx/app/mikmic/id1673212928"
              class="button-store-position"
            >
              <img :src="$themeAsset('appleStore')" class="button-store" />
            </a>
            <h6 class="wow pixFadeUp">{{ $t('register_mark') }}</h6>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import "magnific-popup";
export default {
  name: "faq",
  data() {
    return {
      questions: [],
      searchTerm: "",
      selectedCategory: "all",
      supportEmail: "contacto@mikmic.com",
      supportPhone: "3317382691"
    };
  },
  computed: {
    supportPhoneLabel() {
      return "331 738 2691";
    },
    whatsAppUrl() {
      return `https://wa.me/52${this.supportPhone}`;
    },
    categoryOptions() {
      const categories = this.questions
        .map((question) => question.category)
        .filter(
          (category) =>
            category !== undefined && category !== null && category !== ""
        );

      const uniqueCategories = [...new Set(categories)];

      return [
        { value: "all", label: this.$t("faq.search.all") },
        ...uniqueCategories.map((category) => ({
          value: String(category),
          label: this.getCategoryLabel(category)
        }))
      ];
    },
    filteredQuestions() {
      const search = this.normalizeText(this.searchTerm);

      return this.questions.filter((question) => {
        const matchesCategory =
          this.selectedCategory === "all" ||
          String(question.category) === this.selectedCategory;
        const searchableText = this.normalizeText(
          `${question.questions || ""} ${this.stripHtml(question.answer || "")}`
        );
        const matchesSearch = !search || searchableText.includes(search);

        return matchesCategory && matchesSearch;
      });
    }
  },
  mounted() {
    window.$(".popup-video").magnificPopup({
      disableOn: 700,
      type: "iframe",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
    this.getQuestions();
  },
  methods: {
    async getQuestions() {
      let url = "https://api.mikmic.com/api/";
      await this.axios.post(url + "questions/getAllData").then((response) => {
        this.questions = response.data;
      });
    },
    getCategoryLabel(category) {
      const labels = {
        1: this.$t("faq.categories.customers"),
        2: this.$t("faq.categories.drivers"),
        3: this.$t("faq.categories.vehicles"),
        4: this.$t("faq.categories.general"),
        customers: this.$t("faq.categories.customers"),
        drives: this.$t("faq.categories.drivers"),
        drivers: this.$t("faq.categories.drivers"),
        vehicles: this.$t("faq.categories.vehicles"),
        general: this.$t("faq.categories.general")
      };

      return (
        labels[category] ||
        labels[String(category).toLowerCase()] ||
        `${this.$t("faq.search.category")} ${category}`
      );
    },
    stripHtml(value) {
      const div = document.createElement("div");
      div.innerHTML = value;
      return div.textContent || div.innerText || "";
    },
    normalizeText(value) {
      return String(value || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();
    }
  }
};
</script>

<style scoped>
.faq-section {
  background: #ffffff;
  padding: 135px 0 110px;
}

.faq-shell {
  max-width: 980px;
  margin: 0 auto;
}

.faq-heading {
  margin-bottom: 34px;
}

.faq-kicker {
  margin-bottom: 10px;
  color: #6d2df7;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.faq-intro {
  max-width: 700px;
  margin: 16px auto 0;
  color: #6f6b82;
  font-size: 16px;
  line-height: 1.7;
}

.faq-search-panel {
  padding: 24px;
  border: 1px solid #ece7fb;
  border-radius: 8px;
  background: #f8f6ff;
  box-shadow: 0 18px 45px rgba(21, 13, 63, 0.08);
}

.faq-search-box {
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 58px;
  padding: 0 18px;
  border: 2px solid transparent;
  border-radius: 8px;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.faq-search-box:focus-within {
  border-color: #6d2df7;
  box-shadow: 0 0 0 4px rgba(109, 45, 247, 0.12);
}

.faq-search-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #00e8b8;
  color: #150d3f;
  font-weight: 900;
}

.faq-search-input {
  width: 100%;
  border: 0;
  outline: 0;
  color: #150d3f;
  font-size: 17px;
  font-weight: 600;
  background: transparent;
}

.faq-search-input::placeholder {
  color: #8a849d;
  font-weight: 500;
}

.faq-category-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 18px;
}

.faq-category-button {
  min-height: 38px;
  padding: 0 16px;
  border: 1px solid #ddd4fb;
  border-radius: 8px;
  color: #150d3f;
  font-weight: 700;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.faq-category-button.active,
.faq-category-button:hover {
  border-color: #6d2df7;
  background: #6d2df7;
  color: #ffffff;
}

.faq-results-summary {
  margin: 26px 0 14px;
  color: #6f6b82;
  font-size: 14px;
  font-weight: 700;
}

.faq-list {
  display: grid;
  gap: 12px;
}

.faq-item {
  border: 1px solid #ece7fb;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(21, 13, 63, 0.06);
  overflow: hidden;
}

.faq-question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 20px 22px;
  color: #150d3f;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.4;
  cursor: pointer;
  list-style: none;
}

.faq-question::-webkit-details-marker {
  display: none;
}

.faq-toggle {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #f0ebff;
  color: #6d2df7;
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
}

.faq-item[open] .faq-toggle {
  background: #00e8b8;
  color: #150d3f;
  transform: rotate(45deg);
}

.faq-answer {
  padding: 0 22px 22px;
  color: #6f6b82;
  font-size: 15px;
  line-height: 1.75;
}

.faq-answer ::v-deep ul {
  padding-left: 22px;
  margin-bottom: 16px;
}

.faq-answer ::v-deep p {
  margin-bottom: 12px;
}

.faq-empty {
  padding: 34px 24px;
  border: 1px dashed #d9cef8;
  border-radius: 8px;
  text-align: center;
  background: #fbfaff;
}

.faq-empty h4 {
  margin-bottom: 8px;
  color: #150d3f;
  font-size: 20px;
}

.faq-empty p {
  margin: 0;
  color: #6f6b82;
}

.faq-contact-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-top: 28px;
  padding: 24px;
  border-radius: 8px;
  background: #150d3f;
  box-shadow: 0 18px 45px rgba(21, 13, 63, 0.14);
}

.faq-contact-kicker {
  margin: 0 0 6px;
  color: #00e8b8;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.faq-contact-card h4 {
  margin: 0 0 8px;
  color: #ffffff;
  font-size: 22px;
  line-height: 1.25;
}

.faq-contact-card p {
  margin: 0;
  color: #d9d3f5;
  font-size: 15px;
  line-height: 1.6;
}

.faq-contact-actions {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
}

.faq-contact-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  padding: 0 18px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 800;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.faq-contact-button.primary,
.faq-contact-button:hover {
  border-color: #00e8b8;
  background: #00e8b8;
  color: #150d3f;
}

.faq-contact-button.whatsapp {
  gap: 8px;
}

.faq-contact-button.whatsapp:hover,
.faq-contact-button.whatsapp:focus {
  border-color: #25d366;
  background: #25d366;
  color: #102b1a;
}

.faq-contact-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #25d366;
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  line-height: 1;
}

.faq-contact-button:hover .faq-contact-icon,
.faq-contact-button:focus .faq-contact-icon {
  background: #ffffff;
  color: #25d366;
}

@media (max-width: 767px) {
  .faq-section {
    padding: 105px 0 80px;
  }

  .faq-search-panel {
    padding: 16px;
  }

  .faq-question {
    padding: 18px;
    font-size: 16px;
  }

  .faq-answer {
    padding: 0 18px 18px;
  }

  .faq-contact-card {
    align-items: flex-start;
    flex-direction: column;
  }

  .faq-contact-actions {
    width: 100%;
    justify-content: flex-start;
  }

  .faq-contact-button {
    width: 100%;
  }
}
</style>
